import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { RollerSkiView } from "../VIEW/RollerSkiView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function RollerSkiPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.ROLLERSKI}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <RollerSkiView uid={user.uid} />;
}

export default RollerSkiPage;
